import React from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import { Dialog } from '@mui/material';
import Icon from 'components/Icon';
import { Banner, currentBanner, currentWidth } from '../index';
import './index.sass';
import { useLocalStorage } from '@rehooks/local-storage';
import { useLocation } from 'react-router-dom';

const { block, el } = bem('banner-modal');

const BannerModal = () => {

    const [ showBanner, setShowBanner ] = useLocalStorage(currentBanner, false);
    const location = useLocation();

    const { isPhone, isMobile } = useMobile();

    const handleClose = () => {
        setShowBanner(false);
    }

    return (
        <Dialog
            className={block()}
            open={ false }
            onClose={ handleClose }
            fullWidth={ false }
            fullScreen={ false }
            maxWidth={ 'xs' }
            scroll={'body'}
            PaperProps={ {
                sx: {
                    maxWidth: isMobile ? 360 : currentWidth,
                    width: isPhone ? 360 : currentWidth,
                    borderRadius: '20px'
                }
            } }
        >
            <div className={el('header')}>
                <div className={el('close')} onClick={handleClose}><Icon name={'x'}/></div>
            </div>
            <div className={el('content')}>
                <Banner />
            </div>
        </Dialog>
    )
}

export default observer(BannerModal);
